"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tag = void 0;
function tag(ref) {
    var _a = ref, doi = _a.doi, wikipedia = _a.wikipedia, mr = _a.mr, mathse = _a.mathse, mo = _a.mo, name = _a.name;
    if (doi) {
        return { kind: 'doi', id: doi, name: name };
    }
    else if (wikipedia) {
        return { kind: 'wikipedia', id: wikipedia, name: name };
    }
    else if (mr) {
        return { kind: 'mr', id: mr, name: name };
    }
    else if (mathse) {
        return { kind: 'mathse', id: mathse, name: name };
    }
    else {
        return { kind: 'mo', id: mo, name: name };
    }
}
exports.tag = tag;
